export default __webpack_public_path__ + "static/media/msk-museums.774c241c.png";